var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"audit-logs-section"},[_c('div',{staticClass:"al-header"},[_c('div',[_c('export-as-csv-button'),_vm._v(" "),_c('export-as-xlsx-button')],1)]),_vm._v(" "),_c('audit-log-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }